import Resource from './Resource';

export default class GetCityElectedResource extends Resource {
  constructor(token, id) {
    super(token);
    this.id = id;
  }

  async result() {
    try {
      const { data, status } = await this.request.get(`/eleitos/${this.id}`);

      if (status === 200) {
        return data.tse_votacoes; //eslint-disable-line
      }
    } catch (error) {
      console.log(error); //eslint-disable-line
    }
    return {};
  }
}
